// extracted by mini-css-extract-plugin
module.exports = {"doyouhave":"Footer_doyouhave__b7dZ-"};